import React from "react";

const COMMON_PROPS = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
};

function VehicleIcon(props) {
  return (
    <svg {...COMMON_PROPS} {...props}>
      <path d="M4 14h16l-1.6-4.6A2 2 0 0 0 16.5 8h-9a2 2 0 0 0-1.9 1.4L4 14z" />
      <path d="M4 14v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h8v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3" />
      <circle cx="7.5" cy="14.5" r="1.2" />
      <circle cx="16.5" cy="14.5" r="1.2" />
    </svg>
  );
}

function ToolIcon(props) {
  return (
    <svg {...COMMON_PROPS} {...props}>
      <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2-2 2.5-2.5z" />
    </svg>
  );
}

function MiscIcon(props) {
  return (
    <svg {...COMMON_PROPS} {...props}>
      <path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9z" />
      <path d="M3 7.5 12 12l9-4.5" />
      <path d="M12 12v9" />
    </svg>
  );
}

export default function ResourceTypeIcon({ type, ...rest }) {
  if (type === "vehicle") return <VehicleIcon {...rest} />;
  if (type === "tool") return <ToolIcon {...rest} />;
  return <MiscIcon {...rest} />;
}
